import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleFriendsList = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		rx: 100,
		ry: 100,
		width: 40,
		height: 40,
		style: { fill: "#05668D" }
	})]
});
const ForwardRef = forwardRef(SvgCircleFriendsList);
export { ForwardRef as ReactComponent };
